import Request from "@/Request";

export function createBaseReport(payload) {
  return Request({
    url: "/annual-reports/create",
    method: "post",
    data: payload,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

export function createForm(payload) {
  return Request({
    url: "/annual-reports",
    method: "post",
    data: payload,
  });
}

export function deleteReport(payload) {
  return Request({
    url: `/annual-reports/${payload.formID}/delete-all`,
    method: "post",
    data: payload
  });
}

export function deleteForm(payload) {
  return Request({
    url: "/annual-reports/delete",
    method: "post",
    data: payload
  });
}

export function updateForm(payload) {
  return Request({
    url: `/annual-reports/${payload.get("report_id")}/update`,
    method: "post",
    data: payload,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

export function formByID(payload) {
  return Request({
    url: `/annual-reports/${payload.formID}/details`,
    method: "get",
    // params: payload,
  });
}

export function formList(payload) {
  return Request({
    url: "/annual-reports",
    method: "get",
    params: payload,
  });
}

export function formDetails(payload) {  
  return Request({
    url: `/annual-reports/${payload.formID}/item-details`,
    method: "get",
    params: payload,
  });
}
